module.exports = __webpack_public_path__ + "img/logo.30dad990.png";